/*
* Bindings to/from map for highlighting points and segments
*
*/

(function (SG) {
  SG.registerModule('map_bindings');
  SG.bind('initialize:after', function(graph) {
    if(Routes && Routes.activeMap){
      graph.initializeMapBindings();
    } else {
      graph._mapBindingsDisabled = true;
    }
  });

  _.extend(SG.prototype, {
    initializeMapBindings: function() {
      this._onMapHighlightPoint = _.bind(this.onMapHighlightPoint, this)
      this._onMapUnHighlightPoint = _.bind(this.onMapUnhighlightPoint, this)
      this.bindTo(this, 'highlight_at_position', this.highlightPositionOnMap);
      this.bindTo(this, 'mouseout', this.unhighlightPositionOnMap);
      this.bindZoomWithMap();
      this.bindTo(this, 'dataslice:select', this.highlightDataSliceOnMap);
      this.bindTo(rwgps.Events, 'map:highlight_point', this._onMapHighlightPoint);
      this.bindTo(rwgps.Events, 'map:unhighlight_nearest_point', this._onMapUnHighlightPoint);
    },

    removeMapBindings: function() {
      this.unbindFrom(this, 'highlight_at_position', this.highlightPositionOnMap);
      this.unbindFrom(this, 'mouseout', this.unhighlightPositionOnMap);
      this.unbindZoomWithMap();
      this.unbindFrom(this, 'dataslice:select', this.highlightDataSliceOnMap);
      this.unbindFrom(rwgps.Events, 'map:highlight_point', this._onMapHighlightPoint);
      this.unbindFrom(rwgps.Events, 'map:unhighlight_nearest_point', this._onMapUnhighlightPoint);
    },

    bindZoomWithMap: function() {
      this.bindTo(this, 'zoom:in', this.highlightDataSliceOnMap);
      this.bindTo(this, 'zoom:out', this.onZoomOutUnhighlightOnMap);
    },

    disableMapHighlighting: function() {
      if(!this.mapHighlightingDisabled && !this._mapBindingsDisabled) {
        this.unbindZoomWithMap();
        this.bindTo(this, 'zoom:in', this.zoomToDataSliceOnMap);
        this.bindTo(this, 'zoom:out', this.recenterMap);
        this.mapHighlightingDisabled = true;
      }
    },

    enableMapHighlighting: function() {
      if(this.mapHighlightingDisabled && !this._mapBindingsDisabled) {
        this.unbindFrom(this, 'zoom:in', this.zoomToDataSliceOnMap);
        this.unbindFrom(this, 'zoom:out', this.recenterMap);
        this.bindZoomWithMap();
        this.mapHighlightingDisabled = false;
      }
    },

    // this is the best way to "unhighlight" points on the map, because it gives control back
    // to the graph (which might have a zoomed slice or selected segment it wants to highlight
    revertMapHighlightedPoints: function() {
      if(this.segmentSelector) {
        // selected segment gets precedence over zoomed slice
        this.highlightDataSliceOnMap(this.segmentSelector.dataSlice, true);
      } else if(this.zoomedSlice()) {
        this.highlightDataSliceOnMap(this.zoomedSlice(), true);
      } else {
        rwgps.unhighlightPoints(true);
      }
    },

    unbindZoomWithMap: function() {
      this.unbindFrom(this, 'zoom:in', this.highlightDataSliceOnMap);
      this.unbindFrom(this, 'zoom:out', this.onZoomOutUnhighlightOnMap);
    },

    highlightPositionOnMap: function(pointsAroundPosition) {
      rwgps.highlightPoint(pointsAroundPosition.highI, pointsAroundPosition.pct);
    },

    showMarker: function(lng, lat, id) {
      rwgps.showMarker(lng, lat, id);
    },

    removeMarker: function(id) {
      rwgps.removeMarker(id);
    },

    unhighlightPositionOnMap: function() {
      Routes.activeMap.unhighlightNearestPoint();
    },

    zoomToDataSliceOnMap: function(dataSlice) {
      rwgps.zoomToPoints(dataSlice.i, dataSlice.i + dataSlice.count);
    },

    recenterMap: function() {
      Routes.activeMap.recenterMap();
    },

    highlightDataSliceOnMap: function(dataSlice, dontChangeView, doSync) {
      var doit = function() {
        rwgps.highlightPoints(dataSlice.i, dataSlice.i + dataSlice.count, dontChangeView);
      };
      if(doSync) doit();
      else _.defer(doit);
    },

    onZoomOutUnhighlightOnMap: function() {
      rwgps.unhighlightPoints();
    },

    onMapHighlightPoint: function(pointsAroundPosition) {
      if(this.zoomedIn()) {
        var i=pointsAroundPosition.closestI;
        // if outside of zoom bounds, don't highlight!
        var zoomedSlice = this.zoomedSlice();
        if(i < zoomedSlice.i || i >= zoomedSlice.i + zoomedSlice.count) {
          this.defaultMouseOutCleanup();
          return;
        }
      }
      var x = this.pointsAroundToX(pointsAroundPosition);
      if(!x) return; // sometimes the map has data sooner than us
      var closestPoint = this.data()[pointsAroundPosition.closestI];
      this.highlightPointAtX(closestPoint, x);
      this.showPointDetails(closestPoint, x);
    },

    onMapUnhighlightPoint: function() {
      // dont unhighlight the point if we are currently moused over
      // the plot
      if(!this.mouseCurrentlyOver) {
        this.defaultMouseOutCleanup();
      }
    }
  });
})(SampleGraph);



// WEBPACK FOOTER //
// ./public/javascripts/sample_graph/sample_graph.map_bindings.js